import { NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAdminAuth } from '../../hooks/useAdminAuth';

const AdminPageTransactionsApproved = () => {

   const { logoutAdmin } = useAdminAuth();
   const [allTransactions, setAllTransactions] = useState([]);
   const [filteredTransactions, setFilteredTransactions] = useState([]);
   const [activeFilter, setActiveFilter] = useState('all');
   const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(true);

   const urlBase = 'https://pt-api.digit-a.net/api';
   const usersPerPage = 10;

   // traer los datos
   useEffect(() => {
      const fetchData = async () => {
         setLoading(true);
         try {
            const [depositsRes, withdrawalsRes] = await Promise.all([
               fetch(`${urlBase}/transactions/get-transactions`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ status: 'Success' })
               }),
               fetch(`${urlBase}/withdraw/get-withdrawals`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ status: 'Success' })
               })
            ]);

            const depositsData = await depositsRes.json();
            const withdrawalsData = await withdrawalsRes.json();

            const deposits = (depositsData.data || []).map(tx => ({
               id: tx.codeTX,
               orderNumber: tx.orderNumber,
               type: 'DEPOSIT',
               user: tx.user || null,
               amount: tx.amount,
               createdAt: tx.createdAt
            }));

            const withdrawals = (withdrawalsData.data || []).map(tx => ({
               id: tx.codeWithdraw,
               orderNumber: tx.orderNumber,
               type: 'WITHDRAW',
               user: tx.user,
               amount: tx.amount,
               createdAt: tx.createdAt
            }));

            const combined = [...deposits, ...withdrawals]
               .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

            setAllTransactions(combined);

         } catch (error) {
            console.error("Error fetching transactions:", error);
         } finally {
            setLoading(false);
         }
      };

      fetchData();
   }, []);

   // Efecto para los filtros
   useEffect(() => {
      let filtered = [];
      if (activeFilter === 'all') {
         filtered = allTransactions;
      } else if (activeFilter === 'deposit') {
         filtered = allTransactions.filter(tx => tx.type === 'DEPOSIT');
      } else if (activeFilter === 'withdraw') {
         filtered = allTransactions.filter(tx => tx.type === 'WITHDRAW');
      }
      setFilteredTransactions(filtered);
      setCurrentPage(1);
   }, [activeFilter, allTransactions]);


   // Para paginción
   const indexOfLastUser = currentPage * usersPerPage;
   const indexOfFirstUser = indexOfLastUser - usersPerPage;
   const currentTransactions = filteredTransactions.slice(indexOfFirstUser, indexOfLastUser);
   const paginate = (pageNumber) => setCurrentPage(pageNumber);

   return (
      <div className="ppt_admin_content">
         <nav className="navbar navbar-expand-lg p-0 mb-4 mb-lg-5">
            <div className="container-fluid max py-4">
               <div className="row align-items-center justify-content-between w-100">
                  <div className="col-auto">
                     <NavLink to="/dashboard" className="">
                        <img src={process.env.PUBLIC_URL + '/assets/img/lm_logo_propert.svg'} alt="ProperT" border="0" />
                     </NavLink>
                  </div>
                  <div className="col-auto col-lg-6">
                     <div className="collapse navbar-collapse" id="navbarNavDropdown">
                        <div className="col">
                           <nav className="ppt_navdash">
                              <NavLink to="/admin/pending-kyc-users" className="text-black link">USERS</NavLink>
                              <NavLink to="/admin/pending-transactions" className="text-black link">TRANSACTIONS</NavLink>
                           </nav>
                        </div>
                     </div>
                  </div>
                  <div className="col-auto">
                     <span onClick={logoutAdmin} style={{ cursor: 'pointer' }}>
                        <img src={process.env.PUBLIC_URL + '/assets/img/icon_logout_alt.svg'} alt="Logout" border="0" />
                     </span>
                  </div>
               </div>
            </div>
         </nav>
         <div className="container-fluid max">
            <div className="row">
               <div className="col-12 mb-5">
                  <div className="ppt_header d-flex justify-content-between align-items-center">
                     <nav className="ppt_navdash_scd">
                        <NavLink to="/admin/pending-transactions" className="text-black link">Pending Transactions</NavLink>
                        <NavLink to="/admin/approved-transactions" className="text-black link">Approved</NavLink>
                     </nav>
                  </div>
               </div>
               <div className='col-12'>
                  <h4 className="mb-4">Approved transactions</h4>

                  {/* Filtros */}
                  <div className="d-flex align-items-center mb-4 gap-2">
                     <span
                        className={`badge ${activeFilter === 'all' ? 'bg-dark' : 'bg-secondary'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setActiveFilter('all')}>
                        All
                     </span>
                     <span
                        className={`badge ${activeFilter === 'deposit' ? 'bg-primary' : 'bg-secondary'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setActiveFilter('deposit')}>
                        Deposit
                     </span>
                     <span
                        className={`badge ${activeFilter === 'withdraw' ? 'bg-success' : 'bg-secondary'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setActiveFilter('withdraw')}>
                        Withdraw
                     </span>
                  </div>
                  {/* <span className="actions">
                           <span className="btn_denied">Denied</span>
                           <span className="btn_approve">Approve</span>
                  </span> */}

                  {/* Lista de Transacciones */}
                  <div className="ppt_admin_genlist">
                     {loading ? <p>Loading...</p> : currentTransactions.map(tx => {
                        const dateObj = new Date(tx.createdAt);
                        const date = dateObj.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
                        const time = `${String(dateObj.getHours()).padStart(2, '0')}:${String(dateObj.getMinutes()).padStart(2, '0')}`;
                        return (
                           <div className="ppt_admin_genlist_item" key={`${tx.type}-${tx.id}-${tx.createdAt}`}>
                              <span className="user">
                                 <img src={process.env.PUBLIC_URL + '/assets/img/icon_user_alt.svg'} alt="User" border="0" />
                                 <div>
                                    <p className="mb-0">{tx.user || '---'}</p>
                                    <small className='text-muted' style={{ fontSize: '0.65em' }}>Order Number: {tx.orderNumber || '---'}</small>
                                 </div>
                              </span>
                              <span className="date">{date}</span>
                              <span className="hour">{time}</span>
                              <span className="status">
                                 <span className={`badge ${tx.type === 'DEPOSIT' ? 'bg-primary' : 'bg-success'}`}>{tx.type}</span>
                              </span>
                              <span className="amount">
                                 <span className="code_amount">
                                    <label>{tx.id}</label>
                                    <div>
                                       <input value={tx.amount.toFixed(2)} readOnly />
                                    </div>
                                 </span>
                              </span>
                              <span className="actions">
                              </span>
                           </div>
                        )
                     })}
                  </div>

                  {/* Paginación */}
                  <div className="pagination d-flex justify-content-center m-5">
                     {Array.from({ length: Math.ceil(filteredTransactions.length / usersPerPage) }, (_, i) => (
                        <button key={i + 1} onClick={() => paginate(i + 1)} className={`btn ${currentPage === i + 1 ? 'btn-warning' : 'btn-outline-secondary'} mx-1`}>
                           {i + 1}
                        </button>
                     ))}
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};
export default AdminPageTransactionsApproved;